import { connect } from 'react-redux';

const mapStateToProps = ({ ApiData }) => ({ ApiData });

export default (WrappedComponent) => connect(mapStateToProps, {})(WrappedComponent);
